export default "__VITE_ASSET__CYWXzcYq__"